<template>
  <div>
    <Form
      page-title="Add a new Table"
      buttonName="Submit"
      :floorId="floorId"
      :branchId="branchId"
      :businessId="businessId"
      :isCreateMode="true"
      :isInList="isInList"
      @submit="submit"
      ref="TableForm"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { createTable } from "@/API/TablesAPIs";
import { submitAndNotify } from "@/helpers/utils";
export default {
  name: "Create",
  props: ["isInList", "businessId", "branchId", "floorId"],
  components: { Form },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async submit(formData) {
      const callback = () => {
        this.$refs.TableForm.resetForm();
      };
      submitAndNotify(this, createTable(formData), callback);
    }
  }
};
</script>
<style></style>
